// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empperformancepage-inline-1 {
  text-align: center;
  padding: 20px;
}

.empperformancepage-inline-2 {
  margin-bottom: 6px;
}

.empperformancepage-inline-3 {
  font-size: 28px;
  font-weight: 800;
  color: #4f46e5;
}

.empperformancepage-inline-4 {
  font-size: 14px;
  color: #94a3b8;
}

.empperformancepage-inline-5 {
  font-size: 13px;
  color: #2563eb;
  font-weight: 600;
  margin-top: 2px;
}

.empperformancepage-inline-6 {
  text-align: center;
  color: #94a3b8;
  padding: 20px;
}

.empperformancepage-dyn-1 {
  margin: 0 2px;
  color: var(--empperformancepage-1-color);
  font-size: 20px;
}

.empperformancepage-dyn-2 {
  font-weight: 800;
  color: var(--empperformancepage-2-color);
  font-size: 16px;
}

.empperformancepage-dyn-3 {
  color: var(--empperformancepage-3-color);
  font-weight: 700;
}

.empperformancepage-dyn-4 {
  width: var(--empperformancepage-4-width);
  background: var(--empperformancepage-4-background);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Employee/EmpPerformancePage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,kDAAkD;AACpD","sourcesContent":[".empperformancepage-inline-1 {\n  text-align: center;\n  padding: 20px;\n}\n\n.empperformancepage-inline-2 {\n  margin-bottom: 6px;\n}\n\n.empperformancepage-inline-3 {\n  font-size: 28px;\n  font-weight: 800;\n  color: #4f46e5;\n}\n\n.empperformancepage-inline-4 {\n  font-size: 14px;\n  color: #94a3b8;\n}\n\n.empperformancepage-inline-5 {\n  font-size: 13px;\n  color: #2563eb;\n  font-weight: 600;\n  margin-top: 2px;\n}\n\n.empperformancepage-inline-6 {\n  text-align: center;\n  color: #94a3b8;\n  padding: 20px;\n}\n\n.empperformancepage-dyn-1 {\n  margin: 0 2px;\n  color: var(--empperformancepage-1-color);\n  font-size: 20px;\n}\n\n.empperformancepage-dyn-2 {\n  font-weight: 800;\n  color: var(--empperformancepage-2-color);\n  font-size: 16px;\n}\n\n.empperformancepage-dyn-3 {\n  color: var(--empperformancepage-3-color);\n  font-weight: 700;\n}\n\n.empperformancepage-dyn-4 {\n  width: var(--empperformancepage-4-width);\n  background: var(--empperformancepage-4-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
